import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BehaviorSubjectConfirmationService } from 'src/app/shared/services/behavior-subject-confirmation.service';
import { ContractFormStatusService } from 'src/app/shared/services/contract-form-status.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import * as cities from '../../../../../../../assets/eg.json';
import { ContractStatusNotifierService } from '../../../services/contractStatusNotifier.service';
import { SaveContractDataService } from '../../../services/save-contract-data.service';

@Component({
  selector: 'app-contract-delivery-address',
  templateUrl: './contract-delivery-address.component.html',
  styleUrls: ['./contract-delivery-address.component.scss'],
})
export class ContractDeliveryAddressComponent implements OnInit, AfterViewInit {
  fvDeliveryAddress = new FormValidatorService();
  deliveryAddressForm!: FormGroup;
  cities: string[];
  showContractAlert;
  contractStatus;
  constructor(
    private translate: TranslateService,
    private saveContractData: SaveContractDataService,
    private behaviourSubjectContract: BehaviorSubjectConfirmationService,
    private snackBar: MatSnackBar,
    private contractServNotifier: ContractStatusNotifierService,
    private router:Router,
    private auth:AuthService,
    private contractFormStatusService: ContractFormStatusService
  ) {}

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.fvDeliveryAddress.validationMessages = {
        contractDeliveryArea: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Delivery Area',
            fieldAr: 'منطقة التسليم',
          }),
        },
        contractDeliveryAddress: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Delivery Address',
            fieldAr: 'عنوان التسليم',
          }),
        },
      };
    });
  }
  ngOnInit(): void {
    this.contractServNotifier.getStatusNotification().subscribe(res=>{
      this.contractStatus=res;
    })
    this.cities = (cities as any).default;
    this.deliveryAddressForm = this.fvDeliveryAddress.createForm([
      {
        fieldName: 'contractDeliveryGovernate',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'contractDeliveryArea',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'contractDeliveryAddress',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'contractDeliveryDuration',
        defaultValue: 3,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);
  }
  initFormValues(oldContractData) {
    this.contractStatus=oldContractData.Business.contractStatus;
    this.deliveryAddressForm.controls['contractDeliveryGovernate'].setValue(
      oldContractData.contractDeliveryGovernate
    );
    this.deliveryAddressForm.controls['contractDeliveryArea'].setValue(
      oldContractData.contractDeliveryArea
    );
    this.deliveryAddressForm.controls['contractDeliveryAddress'].setValue(
      oldContractData.contractDeliveryAddress
    );
    let contractDeliveryDuration = oldContractData.contractDeliveryDuration;
    if (!contractDeliveryDuration) {
      contractDeliveryDuration = 3;
    }
    this.deliveryAddressForm.controls['contractDeliveryDuration'].setValue(
      contractDeliveryDuration
    );
  }
  async onConfirmContract() {
    try{
    if (this.deliveryAddressForm.invalid) {
      this.fvDeliveryAddress.forceShowErrors();
      return;
    }
    const formData = new FormData();
    const outputObject = { ...this.deliveryAddressForm.value };
    outputObject.confirm = true;
    for (const name of Object.keys(outputObject)) {
      if (outputObject[name]) formData.append(name, outputObject[name]);
    }
    this.saveContractData.setParams(formData);
    await this.saveContractData.make();

    await this.updateBusinessLocalStorage('confirmed');
    this.showMessage(
      this.translate.instant('Sellers.Products.ContactDetailsAwaits')
    );
      this.router.navigate(['seller/dashboard']);
    this.showContractAlert = true;
    }catch(err){
      console.log(err);
    }
  }
  showMessage(message: string) {
    this.snackBar.open(message, null, {
      duration: 3000,
    });
  }
  async updateBusinessLocalStorage(status: any) {
    this.contractServNotifier.pushStatusNotification(status);
    this.behaviourSubjectContract.renderData.next(true);
    const business = await this.auth.getBusiness();
    business.contractStatus = status;
    this.auth.setBusiness(business);
  }
  convertDeliveryAddressFormControls(name: string) {
    return this.deliveryAddressForm.get(name) as FormControl;
  }

  disable() {
    return !this.contractFormStatusService.getContractFormStatus(1);
  }
}
